import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useAuth } from '../../hooks/useAuth';
import { fetchComments } from '../../api/reviews';
import ReactionBar from './ReactionBar';
import CommentForm from './CommentForm';
import CommentCard from './CommentCard';
import './reviews.css';

export default function ReviewSection({ eventPk }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated } = useAuth();

    const requireLogin = (action) => {
        if (isAuthenticated) return true;
        if (
            window.confirm(
                `You need to login to ${action}. Go to login page?`,
            )
        ) {
            navigate('/login', { state: { from: location } });
        }
        return false;
    };

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading,
    } = useInfiniteQuery({
        queryKey: ['comments', eventPk],
        queryFn: ({ pageParam }) => fetchComments(eventPk, pageParam),
        initialPageParam: 1,
        getNextPageParam: (lastPage) =>
            lastPage.next
                ? Number(new URL(lastPage.next).searchParams.get('page'))
                : undefined,
    });

    const comments = data ? data.pages.flatMap((page) => page.results) : [];

    return (
        <section className="review-section">
            <div className="review-divider" />
            <ReactionBar eventPk={eventPk} requireLogin={requireLogin} />
            <CommentForm eventPk={eventPk} requireLogin={requireLogin} />
            <h2 className="review-heading">Review</h2>
            {isLoading && <p className="review-empty">Loading comments...</p>}
            {!isLoading && comments.length === 0 && (
                <p className="review-empty">
                    No comments yet. Be the first to leave one!
                </p>
            )}
            {comments.map((comment) => (
                <CommentCard
                    key={comment.pk}
                    eventPk={eventPk}
                    comment={comment}
                    requireLogin={requireLogin}
                />
            ))}
            {hasNextPage && (
                <button
                    className="review-load-more"
                    onClick={() => fetchNextPage()}
                    disabled={isFetchingNextPage}
                >
                    {isFetchingNextPage ? 'Loading...' : 'Load more'}
                </button>
            )}
        </section>
    );
}
